import { Dropdown, Collapse, Modal } from 'bootstrap';
import 'mmenu-light';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", () => {

  jQuery(function ($) {
    $(document.body).on('removed_from_cart', function () {
      $(document.body).trigger('wc_fragment_refresh');
    });
  });

  // -----------------------------------------------------------------------------
  // MENUS
  // -----------------------------------------------------------------------------

  // Custom Mega Menu
  const triggers = document.querySelectorAll(".mega-menu-trigger .nav-link");
  const backdrop = document.querySelector(".mega-menu-backdrop");
  let activeTrigger = null;

  triggers.forEach(trigger => {
    trigger.addEventListener("click", event => {
      event.preventDefault();
      // If the backdrop is already open and the same trigger is clicked, close the backdrop
      if (backdrop.classList.contains("show") && activeTrigger === trigger) {
        backdrop.classList.remove("show");
        activeTrigger = null;
      } else {
        // If a different trigger is clicked, show the backdrop and update the active trigger
        backdrop.classList.add("show");
        activeTrigger = trigger;
      }
    });
  });

  // Close the mega menu backdrop when clicking outside of it
  document.addEventListener('click', function (e) {
    // If click is outside any collapse and outside toggler buttons
    if (!e.target.closest('.collapse') && !e.target.closest('[data-bs-toggle="collapse"]')) {
      document.querySelectorAll('.collapse.show').forEach(function (el) {
        // If the element is a navbar-collapse, skip it
        if (el.classList.contains('navbar-collapse')) {
          return;
        }
        const collapseInstance = Collapse.getInstance(el);
        if (collapseInstance) {
          collapseInstance.hide();
        } else {
          const newInstance = new Collapse(el, { toggle: false });
          newInstance.hide();
        }
        if (backdrop) {
          backdrop.classList.remove('show');
        }
        activeTrigger = null;
      });
    }
  });

  // Mmenu Light https://mmenujs.com/mmenu-light/tutorial.html
  const mobileMenu = document.querySelector("#mobileMenu");
  if (mobileMenu) {
    const menu = new MmenuLight(mobileMenu);
    const navigator = menu.navigation({ title: 'MENU' });
    const drawer = menu.offcanvas();
    const api = menu.api;

    const menuTrigger = document.querySelector('a[href="#mobileMenu"]');
    if (menuTrigger) {
      menuTrigger.addEventListener("click", event => {
        event.preventDefault();
        drawer.open(); // this opens ths off-canvas menu. Presumably, event listeners have NOT been added and so do NOT fire?
      });
      
      // https://stackoverflow.com/questions/10612024/event-trigger-on-a-class-change
      // define variable so we can ADD and REMOVE a listener below
      const mobileMenuClickListener = function(event) {
        // gtm.linkClick
        // https://www.simoahava.com/analytics/simple-custom-event-listeners-gtm/
        // https://www.simoahava.com/gtm-tips/use-eventtimeout-eventcallback/
        event.preventDefault(); // DO NOT follow HREF yet!
        // on LIVE a CLICK push sets gtm.triggers between the LINKCLICK of the BURGER and then of the MENU ITEM
        // so the LINKCLICK inherits the WRONG value for gtm.triggers
        // so we need to find the CORRECT value for TRIGGERS and pass it our PUSH
        // since we can't just inherit fromt the previous PUSH!
        var targetUrl = event.target.href, target = event.target.target || '', gtm_triggers = '';
        window.dataLayer.some(evt => {
            // use bracket syntax to access properties with dot in their names
            if('gtm.linkClick' === evt.event && 'navbar-toggle' === evt['gtm.eventClasses']) {
                gtm_triggers = evt['gtm.triggers'];
                return true; // return TRUE to some() wil "break" and not iterate any more
            }
            return false; // return FALSE to keep iterating
        });
        window.dataLayer.push({
             'event': 'gtm.linkClick',
             'gtm.element': event.target,
             'gtm.elementClasses': event.target.ClassName || '',
             'gtm.elementId': event.target.id || '',
             'gtm.elementTarget': event.target.target || '',
             'gtm.triggers': gtm_triggers,
             'gtm.elementUrl': event.target.href || event.target.action || '',
             'gtm.elementText': event.target.innerText,
             'gtm.willOpenInNewWindow': target.length > 0,
             'gtm.originalEvent': event,
             'eventCallback': function() {
                 if(target.length > 0) {
                     //window.open(targetUrl, target).focus(); // open other tab
                     Object.assign(document.createElement('a'), { target: target, href: targetUrl}).click()
                 } else {
                    window.location = targetUrl; // just navigate
                }
             },
             'eventTimeout': 2000
         });
      };
      const classNameObserver = new MutationObserver((mutations) => {
          mutations.forEach(mu => { https://developer.mozilla.org/en-US/docs/Web/API/MutationRecord
            if (mu.type !== "attributes" && mu.attributeName !== "class") return;
            console.log("class was modified!");
            if (mu.target.classList.contains('mm-ocd-opened')) {
                // drawer has been OPENED
                document.querySelectorAll("#mobileMenu a[href]:not([href^='#'])").forEach(elt => {
                    elt.addEventListener('click', mobileMenuClickListener);
                });
                
            } else if(mu.target.classList.contains('mm-ocd-closed')) {
                // draw has been CLOSED
                document.querySelectorAll("#mobileMenu a[href]:not([href^='#'])").forEach(elt => {
                    elt.removeEventListener('click', mobileMenuClickListener);
                });
            }
        });
      });
      const bodyClassNameObserver = classNameObserver.observe(document.body, {attributes: true});
    }
  }

  // Replace empty <a> with a <span> this way the anchor to open the submenu will fill up the entire <li>.
  document.querySelectorAll(".mm-ocd a:not([href])").forEach(anchor => {
    let span = document.createElement("span");
    span.innerHTML = anchor.innerHTML;
    for (let { name, value } of anchor.attributes) {
      if (name !== "href") {
        span.setAttribute(name, value);
      }
    }
    anchor.replaceWith(span);
  });


  // -----------------------------------------------------------------------------
  // SWIPERS
  // -----------------------------------------------------------------------------

  // Hero
  new Swiper(".hero-swiper", {
    modules: [Autoplay, Pagination],
    speed: 900,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    loop: true,
  });

  // Featured Products
  new Swiper(".featured-products-swiper", {
    modules: [Navigation],
    navigation: {
      nextEl: ".featured-products .swiper-next",
      prevEl: ".featured-products .swiper-prev",
    },
    slidesPerView: 1.3,
    slidesPerGroup: 1,
    spaceBetween: 30,
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      992: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
  });

  // Guides and Advice
  new Swiper(".guides-and-advice-swiper", {
    modules: [Navigation],
    navigation: {
      nextEl: ".guides-and-advice .swiper-next",
      prevEl: ".guides-and-advice .swiper-prev",
    },
    slidesPerView: 1.2,
    slidesPerGroup: 1,
    spaceBetween: 30,
    breakpoints: {
      992: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
    },
  });

  // Accreditations
  new Swiper(".accreditations-swiper", {
    modules: [Navigation],
    navigation: {
      nextEl: ".accreditations .swiper-next",
      prevEl: ".accreditations .swiper-prev",
    },
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    spaceBetween: 0,
    breakpoints: {
      992: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 30,
      },
    },
  });

  // Customer Reviews
  new Swiper(".customer-reviews-swiper", {
    modules: [Navigation],
    navigation: {
      nextEl: ".customer-reviews .swiper-next",
      prevEl: ".customer-reviews .swiper-prev",
    },
  });

  // Related Products (Single Post)
  new Swiper(".related-products-swiper", {
    modules: [Navigation],
    navigation: {
      nextEl: ".related-products .swiper-next",
      prevEl: ".related-products .swiper-prev",
    },
    slidesPerView: 1.3,
    slidesPerGroup: 1,
    spaceBetween: 30,
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      992: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
  });

});
